import React, { useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { extractDateFromStr, getLatestUpdatedObject } from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";

const WaterLevels = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const navigate = useNavigate();
  const { data: reservoirData = [], isLoading: reservoirIsLoading } =
    useGetProtectedApiDataQuery({
      url: "reservoir-status",
      lang: languageType,
    });

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(getLatestUpdatedObject(reservoirData)?.changed);
  }, [reservoirData]);

  if (reservoirIsLoading) {
    return <Loader />;
  }

  return (
    <div>
      <div>
        <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
      </div>
      <div className="inner-container">
        <div className="row">
          {reservoirData.map((item, index) => (
            <div
              className="col-12 col-sm-12 col-md-3 col-lg-3 mb-4 print-gallery3"
              key={index}
            >
              <div
                className="card-sec wow zoomIn"
                style={{ visibility: "visible", animationName: "zoomIn" }}
              >
                <div className="img-sec">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/reservoir-status/${item.field_path}`);
                    }}
                  >
                    <img
                      alt={item.title}
                      src={
                        item.field_reservoir_image
                          ? `${process.env.REACT_APP_IMAGE_URL}/${item.field_reservoir_image}`
                          : "./images/dummy.png"
                      }
                    />
                  </a>
                </div>
                <div className="desc-sec">
                  <div className="title-sec">
                    <h2>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`/reservoir-status/${item.field_path}`);
                        }}
                      >
                        {item.title}
                      </a>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WaterLevels;
